import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { capitalize } from "../util";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelect(props) {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    props.onChange(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <Select
      multiple
      value={props.value || []}
      onChange={handleChange}
      renderValue={(selected) => selected.map(capitalize).join(", ")}
      MenuProps={MenuProps}
      input={<OutlinedInput label={props.label} />}
    >
      {props.options.map((o) => (
        <MenuItem key={o} value={o}>
          <Checkbox checked={props.value?.includes(o)} />
          <ListItemText primary={capitalize(o)} />
        </MenuItem>
      ))}
    </Select>
  );
}
